import makeStyles from "@mui/styles/makeStyles";
import { Bold, ExtraBold, Regular, SemiBold } from "../../utils";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(/images/mainbackgroundimage.png)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "100vh",
    backgroundColor: theme.palette.primary.main,
    position: "relative",
  },
  grid: {
    justifyContent: "center",
  },
  child: {
    margin: "5% 0% 0% 50%",
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      padding: "12px 0px 0px 12px",
    },
  },
  signupform: {
    padding: "0px 12px 0px 12px",
    backgroundColor: "white",
    boxShadow: "0px 8px 69px #0000001A",
    borderRadius: theme.palette.borderRadius,
    marginTop: "20%",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      marginTop: "6%",
    },
  },
  text: {
    fontSize:"1.5rem",
    fontFamily: ExtraBold,
    color: theme.typography.color.primary,
    marginTop: "0",
  },
  btn: {
    borderRadius: theme.palette.borderRadius,
    boxShadow: "0px 6px 10px #00000014",
    opacity: 1,
    padding: "8px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    height: "40px"
  },
  img: {
    width: "auto",
    height: "21.9px",
  },
  verificationText: {
    fontSize:"0.875rem",
    fontFamily: Regular,
    textAlign: "center",
    color: theme.typography.color.primary,
    backgroundColor: theme.palette.background.secondary,
    borderRadius: theme.palette.borderRadius,
    padding: "20px",
  },
  poweredby: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    fontSize:"0.75rem",
    color: theme.typography.color.tertiary,
  },
  pa: {
    color: theme.typography.color.secondary,
    fontFamily: SemiBold,
    fontSize:"0.75rem",
  },
  companyName: {
    color: theme.typography.color.secondary,
    fontFamily: Bold,
    fontSize:"0.875rem",
    marginLeft: "12px",
  },
  companySelect: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  comapnyImage: {
    width: 50,
    height: 50,
    borderRadius: 0,
  },
  selectCompany: {
    padding: "14px",
    boxShadow: "0px 3px 30px #5C86CB2E",
    margin: "8px 0px",
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    width: "100%",
  },
  selectCompanyBorder: {
    padding: "14px",
    boxShadow: "0px 3px 30px #5C86CB2E",
    margin: "8px 0px",
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
    width: "100%",
  },
  list: {
    overflow: "auto",
    padding: "0px 20px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  content: {
    padding: "22px 20px",
  },
  logoIcon: {
    position: "fixed",
    top: "36px",
    left: "36px",
  },
  filterimg: {
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: theme.palette.borderRadius,
    //marginTop: "4px",
    padding: "12px",
    marginLeft: "16px",
    height: '40px'
  },
  propertyDeatils: {
    color: "#091B29",
    fontSize:"1rem",
    fontFamily: Bold,
    marginTop: "10px",
    marginInlineStart: "8px"
  },
  yearStyle: {
    color: "#4E5A6B",
    fontSize:"0.75rem",
    fontFamily: Bold,
    display: "flex",
    alignItems: "center",
    marginInlineStart: "10px",
  },
  yearFontStyle: {
    color: "#98A0AC",
    fontSize:"0.75rem",
    fontFamily: Bold,
    marginInlineStart: "10px",
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
  },
  marginLeft: {
    // marginLeft: "10px",
    display: "flex",
    alignItems: "center",
  },
  propertyDeatilsBox: {
    display: "flex",
    alignItems: "center",
    padding: "16px 0px",
    borderBottom: "1px solid #E4E8EE",
  },
  addressDeatils: {
    color: "#4E5A6B",
    fontSize:"0.875rem",
    fontFamily: Regular,
    marginInlineStart: "7px",
    direction: "ltr",
    textAlign: "-webkit-match-parent"
  },
  addressDetailsBox: {
    padding: "12px 0px",
    borderBottom: "1px solid #E4E8EE",
  },
  addressBoxFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  detailsContainer: {
    padding: "12px",
  },
  detailsText: {
    color: "#4E5A6B",
    fontSize:"0.875rem",
    fontFamily: Regular,
    marginInlineStart: "7px",
  },
  count: {
    color: "#000",
    fontSize:"0.875rem",
    fontFamily: Bold,
  },
  detailsFlexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0px",
    borderBottom: "1px solid #E4E8EE",
  },
  parentDetailsFlexBox: {
    backgroundColor: "#f5f7fa",
    padding: "16px 16px 0px 16px",
    marginTop: "15px",
  },
  graftParent: {
    border: "1px solid #E4E8EE",
    borderRadius: 4,
    padding: "16px",
    height: "100%",
  },
  dot: {
    borderRadius: "50%",
    width: "6px",
    height: "6px",
  },
  amenitieslist: {
    border: "4px",
    backgroundColor: "#F5F7FA",
    color: "#000",
    fontFamily: Bold,
    fontSize:"0.875rem",
    padding: "10px",
  },
  aminitiesParent: {
    borderTop: "1px solid #E4E8EE",
    marginTop: "15px",
  },
  aminitiesDeatils: {
    color: "#091B29",
    fontSize:"1rem",
    fontFamily: Bold,
    margin: "10px 0px",
  },
  revenueParent: {
    borderRadius: "4px",
    backgroundColor: "#F5F7FA",
    padding: "10px 15px",
    marginTop: "15px",
  },
  revenueBorder: {
    borderTop: "1px solid #E4E8EE",
    marginTop: "16px",
  },
  textCenter: {
    textAlign: "center",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    marginTop: "10px",
  },
  totalCount: {
    color: "#091B29",
    fontSize:"1rem",
    fontFamily: Bold,
    marginLeft: "10px",
  },
  graphPadding: {
    padding: "20px 0px",
  },
  paddingTop: {
    paddingTop: "16px",
  },
  marginTop: {
    marginTop: "8px",
    // borderTop: "1px solid #E4E8EE",
  },
  addressflexBox: {
    display: "flex",
    paddingBottom: "3px",
    alignItems: "center"
  },

}));

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: "4px",
    padding: "12px",
    backgroundColor: theme?.palette?.background?.tertiary1,
    color: theme?.typography?.color?.secondary,
    border: `1px solid ${theme?.palette?.border?.secondary}`,
    boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.04)",
    fontSize:"0.875rem",
    fontFamily: SemiBold,
    cursor: "pointer",
  },
}));